import React from 'react';

import styled from 'styled-components';

import IconSodium from 'components/icons/sodium-flag';
import { CountryCode } from 'generated/rbi-graphql';
import { useLocale } from 'state/intl';

import theme from './theme';

const Sodium = styled(IconSodium)`
  height: 20px;
  margin-bottom: -0.2rem;
  margin-left: 0.2rem;
  fill: ${theme.sodiumFill};
`;
const SodiumDisclaimer = styled.div`
  margin: 0 0 1rem 0;
  padding: 0;
  color: ${theme.sodiumDisclaimerColor};
  font-style: normal;
  font-size: 0.75rem;
  font-family: ${Styles.fontFamily.body};
  a {
    color: ${theme.sodiumDisclaimerArchorColor};
  }
`;

const SodiumDisclaimerUS = () => {
  const { region } = useLocale();
  if (region === CountryCode.US) {
    return (
      <SodiumDisclaimer>
        Warning: <Sodium /> indicates that sodium (salt) content of this item is higher than the
        total daily recommended limit (2,300mg). High Sodium intake can increase blood pressure and
        risk of heart disease and stroke.
      </SodiumDisclaimer>
    );
  }
  return null;
};

export default SodiumDisclaimerUS;
